<template>
  <div :class="divWidthChange" class="conteudoWidth fccObjetos">
    <fccTitlePage :titlePage="titlePage"></fccTitlePage>
    <div class="row">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsAcoes"
          :status="statusAcoes"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :actions="actionsAcoes"
          :optionsButton="optionsAcoes"
          :items="listaAcao"
        >
        </fccTable>
      </div>
    </div>
    <fccModal centered idModal="editAcao" :titleModal="titleModal" escondeFooter travaEsc travaBack>
      <form
        @submit.prevent="objetoAcao.objacaopermid === 0 ? adicionandoAcao() : editandoAcao()"
        autocomplete="off"
      >
        <div class="row innerPage">
          <input type="hidden" v-model="objetoAcao.objacaopermid" />
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="objetoAcao.objacaopermcodigo" required
              >Código</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12">
            <fccInput extraClasses="inputLabel" v-model="objetoAcao.objacaopermdescricao" required
              >Ação</fccInput
            >
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-6">
            <label>Ativo</label><br />
            <toggle-button v-model="objetoAcao.objacaopermativo" />
          </div>
        </div>
        <div class="row innerPage">
          <div class="col-sm-12 text-right">
            <fccButton classeAdd="form-control" tipo="submit">{{ labelsSystem.salvar }}</fccButton>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      fieldsAcoes: [
        { key: 'objacaopermid', label: 'ID', sortable: true },
        { key: 'objacaopermcodigo', label: 'Código', sortable: true },
        { key: 'objacaopermdescricao', label: 'Ação', sortable: true },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          tdClass: 'no-print',
          thClass: 'no-print'
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print' }
      ],
      actionsAcoes: [
        {
          button: true,
          funcaoButton: 'editAcao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteAcao',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      statusAcoes: [
        {
          funcaoButton: 'changeAcao',
          tooltip: 'Alterar Status',
          campoStatus: 'objacaopermativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      optionsAcoes: [
        {
          funcaoButton: 'addAcao',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        },
        { funcaoButton: 'voltaMenu', tooltip: 'Voltar', icon: 'chevron-left' }
      ],
      baseUrlSeguranca: '',
      sortBy: 'ordem',
      titlePage: 'Permissão Objetos',
      titleModal: '',
      itemPorPage: '100',
      titlePDF: 'Permissão Objetos',
      listaAcao: [],
      objetoAcao: []
    }
  },
  methods: {
    voltaMenu: function () {
      this.$router.push({ path: '/seguranca/aplicacoes' })
    },
    changeAcao: function (action, item) {
      this.objetoAcao = item
      this.editandoAcao()
    },
    listandoAcao: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.baseUrlSeguranca + 'Objeto/listarobjacaopermissao',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaAcao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    adicionandoAcao: function () {
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlSeguranca + 'Objeto/adicionarobjacaopermissao',
          this.objetoAcao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoAcao()
          this.objetoAcao = []
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.adicionado, 'success')
          this.$root.$emit('bv::hide::modal', 'editAcao')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    editandoAcao: function () {
      this.carregaTexto(this.codeMensagem('C05'))
      axios
        .put(
          this.baseUrlSeguranca + 'Objeto/alteraracaopermissao',
          this.objetoAcao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoAcao()
          this.objetoAcao = []
          this.carregaTexto()
          this.callToast(this.mensagensUpdate.editado, 'success')
          this.$root.$emit('bv::hide::modal', 'editAcao')
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    deleteAcao: function (action, item) {
      this.callConfirm(this.mensagemExcluir, item.objacaopermdescricao).then((result) => {
        if (result.value) {
          axios
            .delete(
              this.baseUrlSeguranca + 'Objeto/excluiracaopermissao/' + item.objacaopermid,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listandoAcao()
              this.objetoAcao = []
              this.carregaTexto()
              this.callToast(this.mensagensUpdate.excluido, 'success')
              this.$root.$emit('bv::hide::modal', 'editAcao')
            })
            .catch((error) => {
              this.setErrorSystem(error)
            })
        }
      })
    },
    editAcao: function (action, item) {
      this.titleModal = 'Editar Ação'
      this.objetoAcao = item
      this.$root.$emit('bv::show::modal', 'editAcao')
    },
    addAcao: function () {
      this.titleModal = 'Adicionar Ação'
      this.objetoAcao = {
        objacaopermativo: true,
        objacaopermcodigo: '',
        objacaopermdescricao: '',
        objacaopermid: 0
      }
      this.$root.$emit('bv::show::modal', 'editAcao')
    }
  },
  mounted() {
    this.baseUrlSeguranca = this.$fccStore.state.baseUrlSeguranca
    this.listandoAcao()
  }
}
</script>
